import { Item} from "../model";

export class CartItem {
  item: Item;
  quantity:number;

  constructor (item:Item) {
    this.item = item;
    this.quantity = 1
  }

  get price ():number {
    return this.quantity * this.item.price;
  }
}

export class CartEvent {
  constructor(public totalAmount:number, public items:CartItem[]){}
}

export class Cart {
  public items: CartItem[] = [];
  public remark:string = "";

  constructor (data:any) {
    this.remark = data.remark;
    if (data.items) {
      this.items = data.items.map((it:any) => {
        let item = new CartItem(new Item(it.item));
        item.quantity = it.quantity;
        return item;
      })
    }
  }

  addToCart(item:Item) {
    let cartItem = this.items.find(it => it.item.id === item.id);
    if (cartItem) {
      cartItem.quantity++;
    } else {
      this.items.push(new CartItem(item))
    }
  }

  clear () {
    this.items = [];
    this.remark = "";
  }

  removeFromCart(item:Item) {
    let i = this.items.findIndex(it => it.item.id === item.id);
    if (i >= 0) {
      this.items.splice(i,1);
    }
  }

  quantityChanged (ci:CartItem) {
    let cartItem = this.items.find(it => it.item.id === ci.item.id);
    if (cartItem) {
      cartItem.quantity = ci.quantity;
    }
  }

  getTotalAmount():number {
    let totalAmount = 0;
    for (let i of this.items) {
      totalAmount += i.price;
    }
    return totalAmount
  }
}

const KK_CART_KEY = 'KK_SHOPPING_CART';

class CartService {

  private subscribers:((event: CartEvent) => void)[] = [];
  private cart:Cart;

  constructor () {
    let cart = sessionStorage.getItem(KK_CART_KEY);
    if (cart) {
      this.cart = new Cart (JSON.parse(cart));
    } else {
      this.cart = new Cart({});
    }
  }

  addToCart(item:Item) {
    this.cart.addToCart(item);
    this.updateCart();
  }

  clear () {
    this.cart.clear();
    this.updateCart();
  }

  removeFromCart(item:Item) {
    this.cart.removeFromCart(item);
    this.updateCart();
  }

  quantityChanged (ci:CartItem) {
    this.cart.quantityChanged(ci);
    this.updateCart();
  }

  getCart():Cart {
    return this.cart;
  }

  setRemark(remark: string) {
    this.cart.remark = remark;
  }


  private updateCart() {
    sessionStorage.setItem(KK_CART_KEY, JSON.stringify(this.cart));

    //notify
    let e = new CartEvent(this.cart.getTotalAmount(), this.cart.items);
    for (let s of this.subscribers) {
      s(e);
    }
  }

  subscribe(callback: (event: CartEvent) => void) {
    this.subscribers.push(callback);
  }

  unSubscribe(callback: (event: CartEvent) => void) {
    let i = this.subscribers.findIndex(it => it === callback);
    if (i >= 0) {
      this.subscribers.splice(i,1);
    }
  }

}

// Export a singleton instance in the global namespace
export const cartService = new CartService();